
export const customModelFields = {
    v_type_presta: 'v_type_presta',
    id: 'TaskID',
    description: 'Description',
    recurrenceRule: 'RecurrenceRule',
    recurrenceId: 'RecurrenceID',
    recurrenceExceptions: 'RecurrenceException'
};

const currentYear = new Date().getFullYear();
export const parseAdjust = (eventDate: any) => {
    const date = new Date(eventDate);
    date.setFullYear(currentYear);
    return date;
};


export const displayDate = new Date(Date.UTC(currentYear, 5, 24));
export const sampleDate: any = (baseData: any[]) => {
    return baseData?.map((dataItem?: any) => ({
        v_cnt1_civ_nom: dataItem?.v_cnt1_civ_nom,
        v_cnt1_tel_fixe: dataItem?.v_cnt1_tel_fixe,
        v_cnt1_tel_mobile: dataItem?.v_cnt1_tel_mobile,
        v_cnt2_id: dataItem?.v_cnt2_id,
        v_cnt2_civ_nom: dataItem?.v_cnt2_civ_nom,
        v_cnt2_tel_fixe: dataItem?.v_cnt2_tel_fixe,
        v_cnt2_tel_mobile: dataItem?.v_cnt2_tel_mobile,
        cli_tel_fixe: dataItem?.cli_tel_fixe,
        cli_tel_mobile: dataItem?.cli_tel_mobile,
        v_desc: dataItem?.v_desc,
        v_cli_civ_nom: dataItem?.v_cli_civ_nom,
        v_nbre_convive: dataItem?.v_nbre_convive,
        v_num_piece: dataItem?.v_num_piece,
        v_rad_avancement: dataItem?.v_rad_avancement,
        v_lieu_civ_nom: dataItem?.v_lieu_civ_nom,
        v_lib_avancement: dataItem?.v_lib_avancement,
        v_type_presta: dataItem?.v_type_presta,
        id: dataItem?.v_num_piece,
        start: parseAdjust(dataItem?.v_hdate_debut),
        startTimezone: dataItem?.startTimezone,
        end: parseAdjust(dataItem?.v_hdate_fin),
        endTimezone: dataItem?.endTimezone,
        isAllDay: dataItem?.isAllDay,
        title: dataItem?.v_cli_civ_nom,
        description: dataItem?.Description,
        recurrenceRule: dataItem?.RecurrenceRule,
        recurrenceId: dataItem?.RecurrenceID,
        recurrenceExceptions: dataItem?.RecurrenceException,
        modeVente: dataItem?.v_mode_vente,
        roomId: dataItem?.RoomID,
        ownerID: dataItem?.OwnerID,
        personId: dataItem?.OwnerID,
        vpr_id: dataItem.vpr_id
    }));
};
